// components/ScrollToTop.tsx
"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { hasPendingAnchor } from "@/lib/anchorScroll";

export default function ScrollToTop() {
    const pathname = usePathname();

    useEffect(() => {
        // Wurde die Seite über einen Anker-Link betreten, übernimmt <AnchorScroll>
        // das Scrollen – sonst würde der Sprung zum Anker sofort wieder nach oben
        // korrigiert.
        if (hasPendingAnchor()) return;

        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return null;
}